import Programming from "../Assets/png/programming.png";
import GameDev from "../Assets/png/ghost.png";
import WebDev from "../Assets/png/internet.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Social from "../Assets/png/social-media.png";
import Digital from "../Assets/png/digital.png";
// import colorSharp from "../Assets/png/white.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br></br> Lorem Ipsum has been the industry's standard dummy text.</p> */}
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                        <div className="item">
                                <img src={Programming} alt="" />
                                <h5>Programming</h5>
                            </div>
                            <div className="item">
                                <img src={GameDev} alt="" />
                                <h5>Game Development</h5>
                            </div>
                            <div className="item">
                                <img src={WebDev} alt="" />
                                <h5>Web Development</h5>
                            </div>
                            <div className="item">
                                <img src={Social} alt="" />
                                <h5>Social Media managment</h5>
                            </div>
                            <div className="item">
                                <img src={Digital} alt="" />
                                <h5>Digital Marketting</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        {/* <img className="background-image-left" src={colorSharp} alt="Image" /> */}
    </section>
  )
}